// import React from "react";
// import {
//   Box,
//   Stack,
//   Typography,
//   Grid,
//   Paper,
//   useMediaQuery,
//   useTheme,
// } from "@mui/material";
// import { motion } from "framer-motion";

// import logo1 from "./logos/logo1.png";
// import logo2 from "./logos/logo2.png";
// import logo3 from "./logos/logo3.png";
// import logo4 from "./logos/logo4.png";
// import logo5 from "./logos/logo5.png";
// import logo6 from "./logos/logo6.png";
// import logo7 from "./logos/logo7.png";
// import logo8 from "./logos/logo8.png";
// import logo9 from "./logos/logo9.png";

// const logos = [
//   { img: logo1, name: "KISSmetrics" },
//   { img: logo2, name: "Motorik" },
//   { img: logo3, name: "Nicorply" },
//   { img: logo4, name: "Software Updater" },
//   { img: logo5, name: "Campfire" },
//   { img: logo6, name: "Webhooks" },
//   { img: logo7, name: "Browser Safety" },
//   { img: logo8, name: "BriteVerify" },
//   { img: logo9, name: "Verified Partner" },
// ];

// const fadeInVariant = {
//   hidden: { opacity: 0, y: 30 },
//   visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
// };

// const Support = () => {
//   const theme = useTheme();
//   const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

//   return (
//     <Box
//       component="section"
//       aria-label="Backed by - Our Partners"
//       sx={{
//         display: {md: "flex", xs: "none"},
//         justifyContent: "center",
//         width: "100%",
//         boxSizing: "border-box",
//         backgroundImage: `url('Bg.svg')`,
//         backgroundRepeat: "no-repeat",
//         backgroundSize: "cover",
//         backgroundPosition: "center",
//         px: { xs: 2, sm: 3, md: 4, lg: 6 },
//         py: { xs: 2, sm: 3, md: 3, lg: 4 },
//         mx: "auto",
//       }}
//     >
//       <Box
//         sx={{
//           maxWidth: { xs: "100%", sm: "90%", md: "1280px" },
//           width: "100%",
//         }}
//       >
//         <motion.div
//           initial="hidden"
//           whileInView="visible"
//           viewport={{ once: true, amount: 0.3 }}
//           variants={fadeInVariant}
//         >
//           <Grid
//             container
//             spacing={isSmallScreen ? 4 : 6}
//             alignItems="flex-start"
//             justifyContent="space-between"
//             mb={{ xs: 1.5, sm: 2, md: 1.5, lg: 4.8 }}
//             mt={{ xs: 0, sm: 0, md: 0, lg: -1.5 }}
//           >
//             {/* Left: Content */}
//             <Grid item xs={12} md={5}>
//               <Stack spacing={2}>
//                 <Stack direction="row" alignItems="center" spacing={2}>
//                   <Box
//                     sx={{
//                       width: "6px",
//                       height: { xs: "22px", sm: "36px", md: "30px" },
//                       backgroundColor: "#054E91",
//                       borderTopRightRadius: "6px",
//                       borderBottomRightRadius: "6px",
//                       mr: 2,
//                     }}
//                   />
//                   <Typography
//                     variant="h4"
//                     component="h2"
//                     sx={{
//                       fontSize: { xs: "22px", sm: "28px", md: "30px" },
//                       color: "#054E91",
//                       fontWeight: 600,
//                       letterSpacing: "0.5px",
//                       fontFamily: "'Roboto', sans-serif",
//                     }}
//                   >
//                     Backed by
//                   </Typography>
//                 </Stack>

//                 <Typography
//                   sx={{
//                     fontSize: { xs: "15px", sm: "17px", md: "20px" },
//                     fontWeight: "400",
//                     lineHeight: { xs: 1.5, sm: 1.8, md: 1.3 },
//                     fontFamily: "'Roboto', sans-serif",
//                     color: "text.secondary",
//                     letterSpacing: "0.3px",
//                     maxWidth: "90%",
//                     mt: 1,
//                   }}
//                 >
//                   Trusted by institutions, accelerators, and innovation
//                   platforms that believe in our journey and support our mission.
//                 </Typography>
//               </Stack>
//             </Grid>

//             {/* Right: Logos */}
//             <Grid item xs={12} md={7}>
//               <Grid container spacing={3}>
//                 {logos.map((logo, idx) => (
//                   <Grid
//                     item
//                     xs={12}
//                     sm={4}
//                     md={4}
//                     key={idx}
//                     sx={{ display: "flex", justifyContent: "center" }}
//                   >
//                     <Box
//                       sx={{
//                         width: "100%",
//                         maxWidth: 200,
//                         minHeight: 130,
//                         // bgcolor: "#ffffff",
//                         bgcolor: "rgba(255, 255, 255, 0.7)",
//                         borderRadius: "16px",
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         p: 2,
//                         transition: "transform 0.3s ease, box-shadow 0.3s ease",
//                         "&:hover": {
//                           transform: "translateY(-4px)",
//                           // boxShadow: 4,
//                         },
//                       }}
//                     >
//                       <Box
//                         component="img"
//                         src={logo.img}
//                         alt={logo.name}
//                         sx={{
//                           maxHeight: 90,
//                           maxWidth: "100%",
//                           objectFit: "contain",
//                           imageRendering: "auto",
//                         }}
//                       />
//                     </Box>
//                   </Grid>
//                 ))}
//               </Grid>
//             </Grid>
//           </Grid>
//         </motion.div>
//       </Box>
//     </Box>
//   );
// };

// export default Support;

/****************************************************************************************************************************************/ 



// import React from "react";
// import {
//   Box,
//   Stack,
//   Typography,
//   Grid,
//   // Paper, // Paper is imported but not used, can remove if not planned for future
//   useMediaQuery,
//   useTheme,
// } from "@mui/material";
// import { motion } from "framer-motion";

// // These logo imports and their usage will remain completely untouched.
// import logo1 from "./logos/logo1.png";
// import logo2 from "./logos/logo2.png";
// import logo3 from "./logos/logo3.png";
// import logo4 from "./logos/logo4.png";
// import logo5 from "./logos/logo5.png";
// import logo6 from "./logos/logo6.png";
// import logo7 from "./logos/logo7.png";
// import logo8 from "./logos/logo8.png";
// import logo9 from "./logos/logo9.png";

// const logos = [
//   { img: logo1, name: "KISSmetrics" },
//   { img: logo2, name: "Motorik" },
//   { img: logo3, name: "Nicorply" },
//   { img: logo4, name: "Software Updater" },
//   { img: logo5, name: "Campfire" },
//   { img: logo6, name: "Webhooks" },
//   { img: logo7, name: "Browser Safety" },
//   { img: logo8, name: "BriteVerify" },
//   { img: logo9, name: "Verified Partner" },
// ];

// const fadeInVariant = {
//   hidden: { opacity: 0, y: 30 },
//   visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
// };

// const Support = () => {
//   const theme = useTheme();
//   const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

//   return (
//     <Box
//       component="section"
//       aria-label="Backed by - Our Partners"
//       sx={{
//         display: { md: "flex", xs: "none" },
//         justifyContent: "center",
//         width: "100%",
//         boxSizing: "border-box",
//         backgroundImage: `url('Bg.svg')`,
//         backgroundRepeat: "no-repeat",
//         backgroundSize: "cover",
//         backgroundPosition: "center",
//         px: { xs: 2, sm: 3, md: 4, lg: 6 },
//         py: { xs: 2, sm: 3, md: 3, lg: 4 },
//         mx: "auto",
//       }}
//     >
//       <Box
//         sx={{
//           maxWidth: { xs: "100%", sm: "90%", md: "1280px" },
//           width: "100%",
//         }}
//       >
//         <motion.div
//           initial="hidden"
//           whileInView="visible"
//           viewport={{ once: true, amount: 0.3 }}
//           variants={fadeInVariant}
//         >
//           <Grid
//             container
//             spacing={isSmallScreen ? 4 : 6}
//             alignItems="flex-start"
//             justifyContent="space-between"
//             mb={{ xs: 1.5, sm: 2, md: 1.5, lg: 4.8 }}
//             mt={{ xs: 0, sm: 0, md: 0, lg: -1.5 }}
//           >
//             {/* Left: Content */}
//             <Grid item xs={12} md={5}>
//               <Stack spacing={2}>
//                 <Stack direction="row" alignItems="center" spacing={2}>
//                   {/* The existing blue vertical bar */}
//                   <Box
//                     sx={{
//                       width: "6px",
//                       height: { xs: "22px", sm: "36px", md: "30px" },
//                       backgroundColor: "#054E91",
//                       borderTopRightRadius: "6px",
//                       borderBottomRightRadius: "6px",
//                       mr: 2,
//                     }}
//                   />
//                   <Typography
//                     variant="h4"
//                     component="h2"
//                     sx={{
//                       fontSize: { xs: "22px", sm: "28px", md: "30px" },
//                       color: "#054E91",
//                       fontWeight: 600,
//                       letterSpacing: "0.5px",
//                       fontFamily: "'Roboto', sans-serif",
//                     }}
//                   >
//                     Backed by
//                   </Typography>
//                 </Stack>

//                 {/* Enhanced descriptive text for more content and visual breaking without new icons */}
//                 <Typography
//                   sx={{
//                     fontSize: { xs: "15px", sm: "17px", md: "20px" },
//                     fontWeight: "400",
//                     lineHeight: { xs: 1.5, sm: 1.8, md: 1.3 },
//                     fontFamily: "'Roboto', sans-serif",
//                     color: "text.secondary",
//                     letterSpacing: "0.3px",
//                     maxWidth: "90%", // Keep original max-width
//                     mt: 1,
//                   }}
//                 >
//                   We are proudly supported by leading{" "}
//                   <Typography
//                     component="span"
//                     sx={{
//                       fontWeight: 600,
//                       color: "#054E91", // Highlight keywords
//                     }}
//                   >
//                     institutions
//                   </Typography>
//                   , dynamic{" "}
//                   <Typography
//                     component="span"
//                     sx={{
//                       fontWeight: 600,
//                       color: "#054E91",
//                     }}
//                   >
//                     accelerators
//                   </Typography>
//                   , and visionary{" "}
//                   <Typography
//                     component="span"
//                     sx={{
//                       fontWeight: 600,
//                       color: "#054E91",
//                     }}
//                   >
//                     innovation platforms
//                   </Typography>{" "}
//                   that deeply believe in our journey and wholeheartedly support
//                   our mission.
//                   <br />
//                   <br />
//                   Their invaluable backing provides us with the essential
//                   resources, expert mentorship, and strategic opportunities
//                   needed to drive impactful innovation and achieve our ambitious
//                   goals. We're committed to leveraging this support to foster
//                   groundbreaking ideas and deliver transformative solutions.
//                 </Typography>

//                 {/* Adding a subtle horizontal rule or separator */}
//                 <Box
//                   sx={{
//                     width: "70%", // Increased width slightly for more presence
//                     height: "1.5px", // Slightly thinner for subtlety
//                     backgroundColor: "#D3DCE5", // Lighter grey, closer to background for blend
//                     borderRadius: "1px",
//                     mt: 3, // Increased top margin to separate from text
//                     mb: 1, // Added bottom margin for spacing
//                     ml: 0, // Ensure left alignment if desired, or 'auto' for center
//                   }}
//                 />

//                 {/* Optional: Add a short, punchy tagline or benefit statement below the line */}
//                 <Typography
//                   variant="body2"
//                   sx={{
//                     fontSize: { xs: "13px", sm: "14px", md: "16px" },
//                     fontStyle: "italic",
//                     color: "text.secondary",
//                     mt: 1,
//                     maxWidth: "85%", // Slightly narrower to fit below the line
//                   }}
//                 >
//                   Driving innovation forward, together.
//                 </Typography>
//               </Stack>
//             </Grid>

//             {/* Right: Logos (remains completely unchanged) */}
//             <Grid item xs={12} md={7}>
//               <Grid container spacing={3}>
//                 {logos.map((logo, idx) => (
//                   <Grid
//                     item
//                     xs={12}
//                     sm={4}
//                     md={4}
//                     key={idx}
//                     sx={{ display: "flex", justifyContent: "center" }}
//                   >
//                     <Box
//                       sx={{
//                         width: "100%",
//                         maxWidth: 200,
//                         minHeight: 130,
//                         bgcolor: "rgba(255, 255, 255, 0.7)",
//                         borderRadius: "16px",
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         p: 2,
//                         transition: "transform 0.3s ease, box-shadow 0.3s ease",
//                         "&:hover": {
//                           transform: "translateY(-4px)",
//                         },
//                       }}
//                     >
//                       <Box
//                         component="img"
//                         src={logo.img}
//                         alt={logo.name}
//                         sx={{
//                           maxHeight: 90,
//                           maxWidth: "100%",
//                           objectFit: "contain",
//                           imageRendering: "auto",
//                         }}
//                       />
//                     </Box>
//                   </Grid>
//                 ))}
//               </Grid>
//             </Grid>
//           </Grid>
//         </motion.div>
//       </Box>
//     </Box>
//   );
// };

// export default Support;

/**************************************************************************************************************************************/ 



import React from "react";
import {
  Box,
  Stack,
  Typography,
  Grid,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { motion } from "framer-motion";
import logo1 from "./logos/logo1.png";
import logo2 from "./logos/logo2.png";
import logo3 from "./logos/logo3.png";
import logo4 from "./logos/logo4.png";
import logo5 from "./logos/logo5.png";
import logo6 from "./logos/logo6.png";
import logo7 from "./logos/logo7.png";
import logo8 from "./logos/logo8.png";
import logo9 from "./logos/logo9.png";

const logos = [
  { img: logo1, name: "KISSmetrics" },
  { img: logo2, name: "Motorik" },
  { img: logo3, name: "Nicorply" },
  { img: logo4, name: "Software Updater" },
  { img: logo5, name: "Campfire" },
  { img: logo6, name: "Webhooks" },
  { img: logo7, name: "Browser Safety" },
  { img: logo8, name: "BriteVerify" },
  { img: logo9, name: "Verified Partner" },
];


const contentFadeInVariant = {
  hidden: { opacity: 0, x: 50 }, // Starts 50px to the right
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.8,
      ease: "easeOut",
    },
  },
};

const logosFadeInVariant = {
  hidden: { opacity: 0, x: -50 }, // Starts 50px to the left
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.8,
      ease: "easeOut", 
    },
  },
};

const Support = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box
      component="section"
      aria-label="Backed by - Our Partners"
      sx={{
        display: { md: "flex", xs: "none" },
        justifyContent: "center",
        width: "100%",
        boxSizing: "border-box",
        backgroundImage: `url('Bg.svg')`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        px: { xs: 2, sm: 3, md: 4, lg: 6 },
        py: { xs: 2, sm: 3, md: 3, lg: 4 },
        mx: "auto",
      }}
    >
      <Box
        sx={{
          maxWidth: { xs: "100%", sm: "90%", md: "1280px" },
          width: "100%",
        }}
      >
        <Grid
          container
          spacing={isSmallScreen ? 4 : 6}
          alignItems="flex-start"
          justifyContent="space-between"
          mb={{ xs: 1.5, sm: 2, md: 1.5, lg: 4.8 }}
          mt={{ xs: 0, sm: 0, md: 0, lg: -1.5 }}
        >
          {/* Left: Content */}
          <Grid item xs={12} md={5}>
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
              variants={contentFadeInVariant} // Applying the content-specific variant
            >
              <Stack spacing={2}>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Box
                    sx={{
                      width: "6px",
                      height: { xs: "22px", sm: "36px", md: "30px" },
                      backgroundColor: "#054E91",
                      borderTopRightRadius: "6px",
                      borderBottomRightRadius: "6px",
                      mr: 2,
                    }}
                  />
                  <Typography
                    variant="h4"
                    component="h2"
                    sx={{
                      fontSize: { xs: "22px", sm: "28px", md: "30px" },
                      color: "#054E91",
                      fontWeight: 600,
                      letterSpacing: "0.5px",
                      fontFamily: "'Roboto', sans-serif",
                    }}
                  >
                    Backed by
                  </Typography>
                </Stack>

                <Typography
                  sx={{
                    fontSize: { xs: "15px", sm: "17px", md: "20px" },
                    lineHeight: { xs: 1.5, sm: 1.8, md: 1.3 },
                    // mb: { xs: 2, sm: 2, md: 1.5, lg: 1.5 },
                    color: "text.secondary",
                    fontFamily: "'Roboto', sans-serif",
                    letterSpacing: "0.5px",
                  }}
                >
                  We are proudly supported by leading institutions, dynamic
                  accelerators and visionary innovation platforms that deeply
                  believe in our journey and wholeheartedly support our mission.
                </Typography>
                <Typography
                  sx={{
                    fontSize: { xs: "15px", sm: "17px", md: "20px" },
                    lineHeight: { xs: 1.6, sm: 1.8, md: 1.3 },
                    mb: { xs: 2, sm: 2, md: 1.5, lg: 1.5 },
                    color: "text.secondary",
                    fontFamily: "'Roboto', sans-serif",
                    letterSpacing: "0.5px",
                  }}
                >
                  Their invaluable backing provides us with the essential
                  resources, expert mentorship, and strategic opportunities
                  needed to drive impactful innovation and achieve our ambitious
                  goals. We're committed to leveraging this support to foster
                  groundbreaking ideas and deliver transformative solutions.
                </Typography>

                {/* Optional: Add a short, punchy tagline or benefit statement below the line */}
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: { xs: "13px", sm: "14px", md: "18px" },
                    fontWeight: "600",
                    fontStyle: "italic",
                    color: "#054E91",
                    mb: 1,
                    maxWidth: "85%",
                  }}
                >
                  Driving innovation forward, together..
                </Typography>
              </Stack>
            </motion.div>
          </Grid>

          {/* Right: Logos - Fades from Left to Right (as a whole block) */}
          <Grid item xs={12} md={7}>
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
              variants={logosFadeInVariant} // Apply the container variant here
            >
              <Grid container spacing={3}>
                {logos.map((logo, idx) => (
                  <Grid
                    item
                    xs={12}
                    sm={4}
                    md={4}
                    key={idx}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    {/* The Box styling for the individual logo cards remains exactly as it was originally */}
                    <Box
                      sx={{
                        width: "100%",
                        maxWidth: 200,
                        minHeight: 130,
                        bgcolor: "rgba(255, 255, 255, 0.7)",
                        borderRadius: "16px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        p: 2,
                        transition: "transform 0.3s ease, box-shadow 0.3s ease",
                        "&:hover": {
                          transform: "translateY(-4px)",
                        },
                      }}
                    >
                      <Box
                        component="img"
                        src={logo.img}
                        alt={logo.name}
                        sx={{
                          maxHeight: 90,
                          maxWidth: "100%",
                          objectFit: "contain",
                          imageRendering: "auto",
                        }}
                      />
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </motion.div>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Support;
